const toggleConfig = {
  SIZE_DROPDOWN_TOGGLE: "SIZE_DROPDOWN_TOGGLE",
  SWATCH_DROPDOWN_TOGGLE: "SWATCH_DROPDOWN_TOGGLE",
  GIFT_CARD_AMOUNT_TOGGLE: "GIFT_CARD_AMOUNT_TOGGLE",
  PINKY_DESIGN_DROPDOWN_TOGGLE: "PINKY_DESIGN_DROPDOWN_TOGGLE",
  LOGIN_FORM_TOGGLE: "LOGIN_FORM_TOGGLE",
  PASSWORD_INFO_TOGGLE: "PASSWORD_INFO_TOGGLE",
  MOTIONPOINT_TOGGLE: "MOTIONPOINT_TOGGLE",
}

export default toggleConfig
